/**
 * Chailease.SystemManagement.API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ApprovedSearch { 
    seq?: number;
    companyId?: number;
    companyName?: string;
    departmentId?: number;
    departmentCode?: string;
    departmentName?: string;
    departmentLevel?: number;
    parentDepartmentId?: number;
    authenticationUserNo?: string;
    authenticationUserName?: string;
    authenticationUserJobTitleId?: number;
    authenticationUserJobTitleName?: string;
    managerUserNo?: string;
    managerUserNoName?: string;
    managerUserJobTitleId?: number;
    managerUserJobTitleName?: string;
    enable?: boolean;
    virtual?: boolean;
}